import { render } from "./syncLogin.vue?vue&type=template&id=6ae61bbc&scoped=true"
import script from "./syncLogin.vue?vue&type=script&lang=js"
export * from "./syncLogin.vue?vue&type=script&lang=js"

import "./syncLogin.vue?vue&type=style&index=0&id=6ae61bbc&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae61bbc"]])

export default __exports__